import React from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import PriorityBadge from '../common/PriorityBadge';

const ConversationCard = ({ topic, relatedTrigger, isExpanded, onToggle }) => {
  // Default values for optional fields
  const timing = topic.timing || "Next meeting";
  const expectedResponse = topic.expectedResponse || "Positive";
  const tone = topic.tone || "Informative";
  const resources = topic.resources || [];
  const talkingPoints = topic.talkingPoints || [];
  
  return (
    <div className="border rounded-lg overflow-hidden">
      <div
        className={`p-4 cursor-pointer flex justify-between items-center ${
          topic.priority === "High" ? 'bg-red-50' : 
          topic.priority === "Medium" ? 'bg-yellow-50' : 
          'bg-blue-50'
        }`}
        onClick={() => onToggle(topic.id)}
      >
        <div className="flex-grow">
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-900">{topic.title}</span>
          </div>
          <div className="text-xs text-gray-500 mt-1 flex items-center">
            <span>Based on: {relatedTrigger ? relatedTrigger.type : topic.type || 'General Assessment'}</span>
            <span className="mx-2">•</span>
            <span>{timing}</span>
          </div>
        </div>
        <div className="flex items-center">
          <span className="mr-3">
            <PriorityBadge priority={topic.priority} />
          </span>
          {isExpanded ? <ChevronUp size={18} className="text-gray-500" /> : <ChevronDown size={18} className="text-gray-500" />}
        </div>
      </div>
      
      {isExpanded && (
        <div className="p-4 bg-white border-t border-gray-100">
          <p className="text-sm text-gray-600 mb-4">{topic.description}</p>
          <div className="mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Recommended Tone:</h4>
            <p className="text-sm text-gray-600 italic">{tone}</p>
          </div>
          <h4 className="text-sm font-medium text-gray-700 mb-2">Talking Points:</h4>
          <ul className="list-none space-y-2 mb-4">
            {talkingPoints.map((point, index) => (
              <li key={index} className="flex items-start text-sm">
                <ArrowRight size={16} className="text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                <span>{point}</span>
              </li>
            ))}
          </ul>
          <div className="bg-gray-50 p-3 rounded-md mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Supporting Resources:</h4>
            <ul className="list-disc pl-5 text-sm text-gray-600">
              {resources.map((resource, index) => (
                <li key={index}>{resource}</li>
              ))}
            </ul>
          </div>
          <div className="flex justify-between mt-4">
            <div className="text-sm text-gray-500">
              Expected client response: <span className="font-medium">{expectedResponse}</span>
            </div>
            <button className="px-3 py-1.5 bg-green-600 rounded-md text-sm font-medium text-white hover:bg-green-700">
              Add to Agenda
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConversationCard;